import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({
  variant = 'primary',
  size,
  to,
  href,
  type,
  onClick,
  disabled,
  ariaDisabled,
  ariaBusy,
  className = '',
  children,
  ...rest
}) => {
  const cls = [
    'cy-btn',
    variant ? `cy-btn--${variant}` : '',
    size ? `cy-btn--${size}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const isDisabled = disabled || ariaDisabled;

  if (to && !isDisabled) {
    return (
      <Link to={to} className={cls} onClick={onClick} {...rest}>
        {children}
      </Link>
    );
  }

  if (href && !isDisabled) {
    return (
      <a href={href} className={cls} onClick={onClick} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button
      type={type || 'button'}
      className={cls}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={ariaDisabled || undefined}
      aria-busy={ariaBusy || undefined}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
